import React from 'react';
import { InfoIcon } from 'lucide-react';
/**
 * Top hero / intro section for the E-Footgear Usage Guide.
 */
export function Hero() {
  return <div className="text-center mb-16" data-id="element-281">
      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-100 text-blue-800 text-sm font-bold uppercase tracking-wider mb-6" data-id="element-282">
        <InfoIcon className="w-4 h-4" data-id="element-283" />
        Buyer's Guide
      </div>
      <h1 className="text-4xl md:text-5xl font-black uppercase tracking-tight mb-6" data-id="element-284">
        E-Footgear <span className="text-blue-600" data-id="element-285">Usage Guide</span>
      </h1>
      <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-286">
        Daedo electronic footgear has evolved. Ensure you have the right
        equipment for your scoring system by understanding the differences
        between the current <strong className="text-gray-900" data-id="element-287">Gen 3</strong> and{' '}
        <strong className="text-gray-900" data-id="element-288">Gen 2</strong> generations.
      </p>
    </div>;
}